import React, { Component } from 'react';
import { object, string } from 'prop-types';
import SlideoutFooter from 'ps-components/Slideout/Footer/SlideoutFooter';
import TableInfoList from 'ps-components/TableInfoList/TableInfoList';
import { applyRounding, parseNumCheckNull } from 'ps-components/lib/formatters';
import { MODEL_TYPE } from '../reducers/GradeListReducer';

export default class GradeListViewFooter extends Component {
  static propTypes = {
    typeOfStructure: string,
    totals: object
  };

  constructor(props) {
    super(props);
    this.formatHeaderData = this.formatHeaderData.bind(this);
    this.formatFooterData = this.formatFooterData.bind(this);
  }

  formatHeaderData() {
    const data = [
      { title: 'Total Jobs', width: '125px' },
      { title: 'Total EEs', width: '95px' },
      { title: 'EE Below Min', width: '95px' },
      { title: 'EE Above Max', width: '96px' },
      { title: 'Cost to Move to Min', width: '130px' },
      { title: 'Avg Compa-Ratio', width: '106px' },
      { title: 'Avg Range Pen', width: '107px' }
    ];

    return data.map((el, idx) => {
      return (
        <div key={idx} style={{ width: el.width }}>
          {el.title}
        </div>
      );
    });
  }

  formatFooterData() {
    const { totals, typeOfStructure, preferences } = this.props;
    const isExisting = MODEL_TYPE.EXISTING === typeOfStructure,
      isNew = MODEL_TYPE.NEW === typeOfStructure;
    return [
      <span key={0}>
        {!isNew && !isExisting && parseNumCheckNull(totals.c_job_count, true)}
        <span className="proposed-text"> {parseNumCheckNull(totals.p_job_count, true)}</span>
      </span>,
      <span key={1}>
        {!isNew && !isExisting && parseNumCheckNull(totals.c_ee_count, true)}
        <span className="proposed-text"> {parseNumCheckNull(totals.p_ee_count, true)}</span>
      </span>,
      <span key={2}>
        {!isNew && parseNumCheckNull(totals.c_below_min, true)}
        <span className="proposed-text"> {parseNumCheckNull(totals.p_below_min, true)}</span>
      </span>,
      <span key={3}>
        {!isNew && parseNumCheckNull(applyRounding(totals.c_above_max, 'monetary', preferences))}
        <span className="proposed-text">
          {' '}
          {parseNumCheckNull(applyRounding(totals.p_above_max, 'monetary', preferences))}
        </span>
      </span>,
      <span key={4}>
        {!isNew && parseNumCheckNull(applyRounding(totals.c_cost_to_move_min, 'monetary', preferences))}
        <span className="proposed-text">
          {' '}
          {parseNumCheckNull(applyRounding(totals.p_cost_to_move_min, 'monetary', preferences))}
        </span>
      </span>,
      <span key={5}>
        {!isNew && applyRounding(totals.c_avg_comp_ratio * 100, 'percent', preferences)}
        <span className="proposed-text"> {applyRounding(totals.p_avg_comp_ratio * 100, 'percent', preferences)}</span>
      </span>,
      <span key={6}>
        {!isNew && applyRounding(totals.c_avg_range_pen * 100, 'percent', preferences)}
        <span className="proposed-text"> {applyRounding(totals.p_avg_range_pen * 100, 'percent', preferences)}</span>
      </span>
    ];
  }

  render() {
    const { totals } = this.props;
    return (
      <SlideoutFooter footerClassName="sma-slideout-footer" isBoxShadowTheme={true}>
        <div className="analytics-total">Total</div>
        {totals && (
          <TableInfoList
            tableClass="sma-slideout-footer-table"
            headerClass="sma-slideout-footer-header"
            cellClass="sma-slideout-footer-cell"
            headers={this.formatHeaderData()}
            data={this.formatFooterData()}
          />
        )}
      </SlideoutFooter>
    );
  }
}
